<template>
  <div>
    <section class="questions">
      <template v-if="question.magicQuestion">
        <div class="quest_img_container">
          <img class="quest_img" :src="question.imgSrc">

          <div class="flex-row mq_badge">
            <img class="mq_book" src="/static/images/game/mq_book.png">

            <p>{{ getTranslations.game_page_magic_question }}</p>
          </div>
        </div>
      </template>

      <template v-else>
        <img class="quest_img" :src="question.imgSrc">
      </template>

      <p class="quest_title">{{ question.text }}</p>

      <template v-if="question.answered">
        <game-answer-item
          :key="`${question.miniGameId}_${question.userAnswerInfo.text}_answered`"
          :text="question.userAnswerInfo.text"
          :choice="question.userAnswerInfo.choice"
          :disabled="true"
          :validated="true"
          :correct="question.correct"
          button-class="right"
        ></game-answer-item>
      </template>

      <template v-else>
        <game-answer-item
          v-for="(answer, index) in answers"
          :key="`${question.miniGameId}_${answer.text}`"
          :text="answer.text"
          :choice="answer.choice"
          :disabled="validatingAnswer"
          :button-class="{right: index === 0}"
          @answer:selected="$emit('answer:selected', {miniGameId: question.miniGameId, answerInfo: $event})"
        ></game-answer-item>
      </template>
    </section>

    <section v-if="question.answered" :class="['answer_msg', question.correct ? 'right_answer' : 'wrong_answer']">
      <div class="flex-row">
        <div class="answer_txt">
          <p>{{ getTranslations.game_page_answer_result_pt1 }} <span>{{ question.correct ? getTranslations.game_page_answer_result_pt2_correct : getTranslations.game_page_answer_result_pt2_wrong }}</span></p>
        </div>

        <div class="answer_points">
          <div class="flex-row">
            <p><span>{{ question.correct ? question.correctPoints : question.wrongPoints }}</span> {{ getTranslations.game_page_answer_points }}</p>

            <img src="/static/images/home/points_star.png">
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import GameAnswerItem from './GameAnswerItem'

export default {
  name: 'GameMain',
  components: {GameAnswerItem},
  emits: ['answer:selected'],
  props: {
    question: {
      type: Object,
      default: () => ({
        text: '',
        imgSrc: '',
        magicQuestion: false,
        answered: false,
        correct: false,
        correctPoints: 0,
        wrongPoints: 0,
        userAnswerInfo: {text: '', choice: ''}
      })
    },
    answers: {
      type: Array,
      default: () => []
    },
    validatingAnswer: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/game/GameMain.vue